import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Module {
  emoji: string;
  title: string;
  chapters: string[];
}
interface ModuleAccordionProps {
  modules: Module[];
}
export function ModuleAccordion({
  modules
}: ModuleAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-100" data-mp="3qrr1hxnvcusj">
      {modules.map((module, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-101" data-mp="3qu3quvvyi7fm" data-mpi={index}>
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200" data-id="element-102" data-mp="4izjrfueyx00">
            <div className="flex items-center gap-3" data-id="element-103" data-mp="1b1o3s56479dx">
              <span className="text-2xl" data-id="element-104" data-mp="1b38x5rgp0ma7">{module.emoji}</span>
              <span className="font-semibold text-gray-900" data-id="element-105" data-mp="37f283jh0593g">
                {module.title}
              </span>
            </div>
            <motion.div animate={{
          rotate: openIndex === index ? 180 : 0
        }} transition={{
          duration: 0.3
        }} data-id="element-106" data-mp="3cddibvb7llm7">
              <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-107" data-mp="3ldsczla2cd2d" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-108" data-mp="2onsyzbb58mce">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-109" data-mp="2tp8kt5l5awvu">
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200" data-id="element-110" data-mp="3dac68w7t0tq0">
                  <ul className="space-y-2" data-id="element-111" data-mp="38dbz0hz7xkxb">
                    {module.chapters.map((chapter, chapterIndex) => <li key={chapterIndex} className="text-gray-700 text-sm flex items-start gap-2" data-id="element-112" data-mp="3n05a1b1pg4jp" data-mpi={chapterIndex}>
                        <span className="text-emerald-500 mt-1" data-id="element-113" data-mp="2ubzmyhn6i3gp">•</span>
                        <span data-id="element-114" data-mp="2pdoeaa8mdz02">{chapter}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}